const MediaCardSkeleton = () => (
  <div className="media-card media-card__skeleton-card">
    <div className="media-card__wrapper">
      <div className="media-card__skeleton-block"></div>
      <div className="media-card__skeleton-block"></div>
      <div className="media-card__skeleton-block"></div>
    </div>
  </div>
);

export default MediaCardSkeleton;
